// src/features/owner/OwnerGuard.tsx — staff-only gate (defense alongside the backend IsStaff perm).
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/hooks';

export function OwnerGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isAdmin } = useSession();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
